import { Injectable } from '@angular/core';
import { Store, Query, StoreConfig } from '@datorama/akita';
import { Observable } from 'rxjs';
import { distinctUntilChanged } from 'rxjs/operators';
import { produce } from 'immer';

export interface PartialCosts {
  id: string;
  totalCosts?: number;
}

export interface TotalCostsState {
  partialCosts: PartialCosts[];
  initializedSections: string[];
}

@Injectable({ providedIn: 'root' })
@StoreConfig({ name: 'totalCostsState', producerFn: produce })
export class TotalCostsStateStore extends Store<TotalCostsState> {
  constructor() {
    super({ partialCosts: [], initializedSections: [] });
  }
}

@Injectable({ providedIn: 'root' })
export class TotalCostsStateQuery extends Query<TotalCostsState> {
  constructor(protected store: TotalCostsStateStore) { super(store); }

  getProjectCosts(): Observable<number> {
    return this
      .select(
        state => state.partialCosts
          .reduce((accumulator, currentValue) => accumulator += currentValue.totalCosts ?? 0, 0))
      .pipe(distinctUntilChanged());
  }

  allTotalCostsRelevantSectionsInitialized(): Observable<boolean> {
    return this
      .select(
        state =>
          !!state.initializedSections.find(s => s === 'csSetup') &&
          !!state.initializedSections.find(s => s === 'projectPreperation') &&
          !!state.initializedSections.find(s => s === 'gridConnection') &&
          !!state.initializedSections.find(s => s === 'csInstallation'))
      .pipe(distinctUntilChanged());
  }
}
